import { getLayoutData, getPageData } from './api/api';
import { LOCALES } from '@repo/utils/constants';
import ExtendedContent from '@/components/common/ExtendedContent';
import Head from 'next/head';
import { useRouter } from 'next/router';
import { FRAGMENTS } from '@repo/ui/lib';
import { GROUP_FRAGMENTS } from '@/lib';
import dynamic from 'next/dynamic';

const StickyHeading = dynamic(() => import('@repo/ui/src/components/StickyHeading'), {
	ssr: false,
});

export default function Home({ data }) {
	const contentData = data?.content || [];
	const { locale } = useRouter();
	const canonicalHref = locale === LOCALES.EN ? `${process.env.SITE_URL}` : `${process.env.SITE_URL}/${LOCALES.PL}`;
	return (
		<>
			<Head>
				<link rel="canonical" href={canonicalHref} hrefLang={locale} key="canonical" />
			</Head>
			<StickyHeading stickyHeadingsSelectors={[]} />
			<ExtendedContent content={contentData} locale={locale} isCurrentPageGroup={true} />
		</>
	);
}

const PAGE_CONTENT_TYPE = 'allGroupSinglePages';

const HOME_PAGE_QUERY = `
	query GetHomePageData($locale: SiteLocale, $slug: String) {
		${PAGE_CONTENT_TYPE}(locale: $locale, filter: {slug: {eq: $slug }}) {
            singlePageName
            slug
            ${FRAGMENTS.SEO_META_FRAGMENT}		
			${FRAGMENTS.THEME_FRAGMENT}
			content{
				__typename
                ${FRAGMENTS.VIDEO_BANNER_FRAGMENT}
				${FRAGMENTS.SOCIAL_MEDIA_FRAGMENT}
				${FRAGMENTS.HORIZONTAL_HEADER_MODULE_FRAGMENT}
				${FRAGMENTS.WHO_WE_WORKED_WITH_MODULE_FRAGMENT}
				${FRAGMENTS.PLEO_BRANCHES_MODULE_FRAGMENT}
				${FRAGMENTS.TEXT_MODULE_FRAGMENT}
				
				${GROUP_FRAGMENTS.FEATURED_PROJECTS_FRAGMENT}
				${GROUP_FRAGMENTS.ABOUT_TEAM_FRAGMENT}
				${GROUP_FRAGMENTS.DESCRIPTION_LOGO_PLEO_FRAGMENT}
				${GROUP_FRAGMENTS.NEWS_THUMBNAILS_FRAGMENT}
				${GROUP_FRAGMENTS.ABOUT_TEAM_FRAGMENT}
                ${GROUP_FRAGMENTS.CHECK_OTHERS_FRAGMENT}
                ${GROUP_FRAGMENTS.SINGLE_ASSET_FRAGMENT}
			}
		}
	}
`;

export async function getStaticProps(context) {
	const locale = context?.locale || 'pl';
	const data = await getPageData(PAGE_CONTENT_TYPE, 'home', HOME_PAGE_QUERY, locale);
	const { globals, cookies, menu, footer } = await getLayoutData(locale);
	return {
		props: {
			data,
			globals,
			cookies,
			locale,
			menu,
			footer,
		},
		revalidate: 120,
	};
}
